import React from 'react';

export const MaskBottom = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="196" height="196" viewBox="0 0 196 196" fill="none">
    <mask id="mask0_6721_153" maskUnits="userSpaceOnUse" x="0" y="0" width="196" height="196">
      <rect width="196" height="196" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_6721_153)">
      <rect x="-63.5039" y="36.2221" width="202.272" height="319.556" rx="101.136" fill="#E8CC42" />
    </g>
  </svg>
);
